import { createSlice } from '@reduxjs/toolkit';

const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    user: {},
    menuData: [
      // {
      //   header: 'Centerline Mobile App',
      //   items: [
      //     { title: 'Frequently Asked Questions', to: '/faq' },
      //     { title: 'Push Notifications - Event Based', to: '/push-events' },
      //     { title: 'Push Notifications - Bulk', to: '/push-bulk' },
      //     { title: 'Surveys Links', to: '/surveys' },
      //     { title: 'News Board', to: '/faq' },
      //   ],
      // },
      // {
      //   header: 'Quote Engine',
      //   items: [{ title: 'Configurations', to: '/quote-config' }],
      // },
      // {
      //   header: 'Driver Qualifications',
      //   items: [{ title: 'Configurations', to: '/driver-config' }],
      // },
      // {
      //   header: 'Dynamic Pricing',
      //   items: [{ title: 'Configurations', to: '/pricing-config' }],
      // },
      {
        header: 'Access',
        items: [
          { title: 'Client Access', to: '/client-users' },
          { title: 'Corporate Access', to: '/corporate-users' },
        ],
      },
      {
        header: 'Configurations',
        items: [
          { title: 'Table Contents', to: '/table-contents' },
          { title: 'AI Prompt Management', to: '/ai-prompt-management' },
        ],
      },
      {
        header: 'Document Management',
        items: [{ title: 'Manuals', to: '/manuals' }],
      },
      // CP-857: BI reference-table maintenance. Filtered to the BI Admin role (and Global
      // Admin) in AdminPortal/index.js.
      //
      // The two TenStreet tables are Centerline-only -- PRST has neither the tables nor the
      // procs behind them, so showing the buttons there would lead to a screen that can only
      // error. Gated at build time on the brand, the same way the routes are; brand is fixed
      // per build, so this is a constant, not a runtime check.
      {
        header: 'BI Administration',
        items: [
          { title: 'SiteList', to: '/site-list' },
          ...(process.env.REACT_APP_BRAND !== 'PRST'
            ? [
                { title: 'Tenstreet Applicant Status', to: '/tenstreet-applicant-status' },
                { title: 'Tenstreet Worklist Xref', to: '/tenstreet-worklist-xref' },
              ]
            : []),
        ],
      },
    ],
  },
  reducers: {
    addUser: (state, { payload }) => {
      state.user = payload;
    },
  },
});

export default adminSlice.reducer;

export const { addUser } = adminSlice.actions;
